<script setup lang="ts">
import type { DSStory } from '@/types'

const props = defineProps({
  story: {
    type: Object as PropType<DSStory>,
    required: true,
  },
})

const { $tracker } = useNuxtApp()
const { getStoryCoverImage } = useStoryBase()
const coverImage = await getStoryCoverImage(props.story)

function trackEvent() {
  $tracker('view_story', { id: props.story.id })
}
</script>

<template>
  <common-custom-link
    :to="`/stories/${story.id}`"
    :title="story.topicTitle"
    :track-event="trackEvent"
    track-component="story-card"
    class-name="block border-b-1 border-neutral-300 pt-4 pb-3 font-handwriting"
  >
    <common-display-image
      class="aspect-1 object-cover w-full"
      :identifier="story.id"
      :image-url="coverImage.thumbnailUrl"
      :alt="`${story.author} - ${story.shortContent}`"
    />
    <p class="px-1 pt-3 text-neutral-400 text-sm">
      {{ story.createdDate }}
    </p>
    <p
      class="px-1 pt-1 text-neutral-800 text-sm line-clamp-1"
    >
      by {{ story.author || '親愛的陌生人' }}
    </p>
    <article class="px-1 pt-1 leading-6 text-neutral-800 text-sm">
      <div
        class="prose-sm text-neutral-700 line-clamp-2 max-h-12"
      >
        {{ story.shortContent }}
      </div>
    </article>
  </common-custom-link>
</template>

<style lang="postcss">
.story-card {
  @apply mb-2 rounded-none bg-silver;
}
</style>
